import { useQueryClient, useMutation } from 'react-query';
import InventoryApi from '@app/api/public/InventoryApi';
import { InventoryFilter } from '@app/api/models/Inventory';
import { filteredProducts } from './useGetFilteredProducts';

export const deleteProductFromFilter = async (product: InventoryFilter) => {
    return InventoryApi.deleteInventoryFilter(product.id);
};

const useDeleteProductFromFilter = () => {
    const queryClient = useQueryClient();

    return useMutation((product: InventoryFilter) => deleteProductFromFilter(product), {
        onMutate: product => {
            queryClient.cancelQueries([...filteredProducts.id(product.id)]);
            queryClient.setQueryData([...filteredProducts.id(product.id)], product);
        },
        onSettled: (_data, _error) => {
            queryClient.invalidateQueries([...filteredProducts.all]);
        }
    });
};

export default useDeleteProductFromFilter;
